import PropTypes from 'prop-types'
import React from 'react'
import './ReversibleArrow.less'

const classNames = require('classnames')

class ReversibleArrow extends React.Component {
  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick()
    }
  }

  render () {
    let arrowClasses = classNames({
      'nmc-reversible-arrow-container': true,
      'nmc-reversible-arrow-reverse-arrow': this.props.reveresedArrow
    })

    return (
      <div className={arrowClasses} onClick={this.handleClick}>
        <span className='nmc-reversible-arrow' />
      </div>
    )
  }
}

ReversibleArrow.propTypes = {
  onClick: PropTypes.func,
  reveresedArrow: PropTypes.bool
}

export default ReversibleArrow



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/ReversibleArrow/index.js